export const formatDecimal = (
  value: number | undefined | null,
  digits = 2,
  locale?: string | undefined
): string => {
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(value ?? 0);
};
